import { TextField } from "@mui/material"
import { IAuthorization, IUser, IUserGroup, IUserGroup_Authorization, IUser_Group } from "bets.oddprovider.lib.common.ts/models"
import { CommonUtils } from "fwork-jsts-common/src"
import { ApiClientUtils } from "fwork-jsts-common/src/apiClient"
import { FormItemStyled, FormStyled } from "fwork.react.apptemplate"
import { useSnackbar } from "notistack"
import React, { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import axios from "../../apiClient/axios"
import { UserGroupsApiClient } from "../../apiClient/userGroups"
import { DEFAULTGAP } from "../../globals"
import { FloatActionButton } from "../common/floatActionButton"
import { UserGroupAddInfoTabsComponent } from "./userGroupAddInfoTabs"

export const UserGroupComponent = (props: {
  id?: number,
}) => {
  const [data, setData] = useState<IUserGroup | undefined>()

  const { enqueueSnackbar } = useSnackbar()
  const navigate = useNavigate()

  const getData = async () => {
    try {
      const response = await new UserGroupsApiClient(axios).get({
        where: {
          id: Number(props.id)
        },
        exclude: '_id',
        nested: 'users{user},authorizations{authorization}',
        sort: { name: 1 }
      })

      if (response.success && response?.data?.payload) {
        setData(response.data?.payload[0])
      }
    } catch (error) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage(error), { variant: 'error' })
    } finally {
    }
  }

  const [saving, setSaving] = useState<boolean>(false)
  const save = async () => {
    if (saving) return
    setSaving(true)
    try {
      if (data) {
        const response =
          data.id ? await new UserGroupsApiClient(axios).put({ data }) : await new UserGroupsApiClient(axios).post({ data })
        if (response.success) {
          if (response.data?.id)
            data.id = response.data?.id
          enqueueSnackbar('Alterações salvas com sucesso.', { variant: 'success' })
        }
        else
          enqueueSnackbar(response.msg || 'Erro ao salvar alterações.', { variant: 'error' })
      }
    } catch (error) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage(error), { variant: 'error' })
    }
    finally {
      setSaving(false)
    }
  }

  useEffect(() => {
    if (props.id)
      getData()
    else setData({} as IUser_Group)
  }, [])

  return <>
    <FormStyled gap={DEFAULTGAP}>
      <FormItemStyled gap={DEFAULTGAP}>
        <TextField
          InputLabelProps={{ shrink: true }}
          value={data?.name || ''}
          label={"Nome"}
          onChange={(e) => setData({
            ...data,
            name: e.target.value
          } as IUserGroup)}
        />
      </FormItemStyled>

      <UserGroupAddInfoTabsComponent
        users_groups={data?.users}
        onSelectUser={(u_g: IUser_Group, user: IUser) => {
          let userTmp = data?.users?.filter(u => u.user?.id == user.id && u.uuid !== u_g.uuid)
          if (userTmp?.length) {
            enqueueSnackbar('Usuário já adicionado', { variant: 'error' })
            return
          }

          let users_groups = [...data?.users || []]
          for (let oldU_g of users_groups) {
            if (oldU_g.uuid === u_g.uuid) {
              oldU_g.user_id = user.id
              oldU_g.user = user
              break
            }
          }
          setData({
            ...data,
            users: users_groups
          } as IUserGroup)
        }}
        onDeleteUser={(item: IUser_Group) => {
          setData({
            ...data,
            users: data?.users?.filter(u => u.uuid != item.uuid)
          } as IUserGroup)
        }}
        onAddUser={() => {
          const users = [...data?.users || []]

          if (users?.filter(g => g.usergroup_id == 0).length)
            return

          users.push({
            uuid: CommonUtils.getNewUuid(),
            id: 0,
            user_id: 0,
            usergroup_id: data?.id || 0
          })
          setData({
            ...data,
            users,
          } as IUserGroup)
          console.log(users)
        }}

        //AUTHORIZATIONS
        usersgroups_authorizations={data?.authorizations}
        onSelectAuthorization={(u_g: IUserGroup_Authorization, authorization: IAuthorization) => {
          let authorizationTmp = data?.authorizations?.filter(a => a.authorization?.id == authorization.id &&
            a.uuid !== u_g.uuid)
          if (authorizationTmp?.length) {
            enqueueSnackbar('Autorização já cadastrada', { variant: 'error' })
            return
          }
          let usersgroups_authorizations = [...data?.authorizations || []]
          for (let oldU_g of usersgroups_authorizations) {
            if (oldU_g.uuid === u_g.uuid) {
              oldU_g.authorization_id = authorization.id
              oldU_g.authorization = authorization
              break
            }
          }
          setData({
            ...data,
            authorizations: usersgroups_authorizations
          } as IUserGroup)
        }}
        onDeleteAuthorization={(item: IUserGroup_Authorization) => {
          setData({
            ...data,
            authorizations: data?.authorizations?.filter(u => u.uuid != item.uuid)
          } as IUserGroup)
        }}
        onAddAuthorization={() => {
          const authorizations = [...data?.authorizations || []]

          if (authorizations?.filter(g => g.authorization_id == 0).length)
            return

          authorizations.push({
            uuid: CommonUtils.getNewUuid(),
            id: 0,
            authorization_id: 0,
            usergroup_id: data?.id || 0
          })
          setData({
            ...data,
            authorizations,
          } as IUserGroup)
        }}
      />

      <FloatActionButton progress={saving} onCancelClick={() => navigate(-1)} onConfirmClick={save} />
    </FormStyled>
  </>
}